import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4696d558"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "mx-3" }
const _hoisted_4 = { class: "row border" }
const _hoisted_5 = { class: "col-2 border-end p-4" }
const _hoisted_6 = { class: "d-flex justify-content-center mb-3" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, "User", -1))
const _hoisted_8 = { class: "col-10 p-4 position-relative" }
const _hoisted_9 = {
  key: 0,
  class: "card mt-4 ps-4 pt-2"
}
const _hoisted_10 = { class: "mt-10" }
const _hoisted_11 = { class: "d-flex gap-3 mt-5" }
const _hoisted_12 = { class: "time" }
const _hoisted_13 = { class: "col-2 border-end p-4" }
const _hoisted_14 = { class: "d-flex justify-content-center mb-3" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, "User", -1))
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "text-center" }
const _hoisted_19 = { class: "col-10 p-4 position-relative" }
const _hoisted_20 = {
  key: 0,
  class: "card mt-4 ps-4 pt-2"
}
const _hoisted_21 = { class: "mt-10" }
const _hoisted_22 = { class: "d-flex gap-3 mt-5" }
const _hoisted_23 = { class: "time" }

import { ref } from "vue";
import SupportService from "../services/SupportService";
import { CaseStatusTypes } from "@/core/types/SupportStatusTypes";
import ReplyCase from "./ReplyCase.vue";
import CaseImages from "./CaseImages.vue";
import TranslateText from "./TranslateText.vue";
import { computed } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'CaseDetail',
  setup(__props, { expose: __expose }) {

const isLoading = ref(false);
const drawer = ref(false);
const data = ref(<any>[]);
const title = ref("");
const id = computed(() => data.value.id);
const showTranslation = ref(true);
const show = (_item: any) => {
  drawer.value = true;
  fetchData(_item.id);
};

const fetchData = async (id: number) => {
  isLoading.value = true;
  try {
    const res = await SupportService.queryCaseById(id);
    data.value = res;
    title.value = res.caseId;
  } catch (error) {
    console.log(error);
  }
  isLoading.value = false;
};

const replied = () => {
  fetchData(data.value.id);
};

__expose({
  show,
});

return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_TimeShow = _resolveComponent("TimeShow")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_UserAvatar = _resolveComponent("UserAvatar")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    modelValue: drawer.value,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((drawer).value = $event)),
    direction: "ltr",
    size: "90%"
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_component_el_tag, {
          type: "success",
          size: "large",
          class: "fs-4 me-3"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Case ID: " + _toDisplayString(data.value.caseId), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_tag, {
          type: "success",
          size: "large",
          class: "fs-4 me-3"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Category: " + _toDisplayString(_ctx.$t("title." + data.value.categoryName)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_tag, {
          type: "success",
          size: "large",
          class: "fs-4 me-3"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Status: " + _toDisplayString(_unref(CaseStatusTypes)[data.value.status]), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_tag, {
          type: "success",
          size: "large",
          class: "fs-4 me-3"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_TimeShow, {
              "date-iso-string": data.value.createdOn
            }, null, 8, ["date-iso-string"])
          ]),
          _: 1
        }),
        (data.value.claimedAdminName != '')
          ? (_openBlock(), _createBlock(_component_el_tag, {
              key: 0,
              type: "success",
              size: "large",
              class: "fs-4 me-3"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Claimed By: " + _toDisplayString(data.value.claimedAdminName), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_el_button, {
        class: "me-4",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (showTranslation.value = !showTranslation.value))
      }, {
        default: _withCtx(() => [
          (showTranslation.value == false)
            ? (_openBlock(), _createElementBlock("span", _hoisted_1, " Show Translation"))
            : (_openBlock(), _createElementBlock("span", _hoisted_2, "Hide Translation"))
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_UserAvatar, {
                avatar: "",
                name: "User",
                side: "client",
                size: "100px",
                rounded: ""
              })
            ]),
            _hoisted_7
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", null, _toDisplayString(data.value.content), 1),
            (showTranslation.value && data.value.languages?.length != 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value.languages, (languageObject, index) => {
                    return (_openBlock(), _createElementBlock("div", { key: index }, [
                      _createElementVNode("p", null, _toDisplayString(Object.keys(languageObject)[0]) + ": " + _toDisplayString(Object.values(languageObject)[0]), 1)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(TranslateText, {
                text: data.value.content,
                case: data.value,
                onTranslated: _cache[1] || (_cache[1] = ($event: any) => (fetchData(id.value)))
              }, null, 8, ["text", "case"])
            ]),
            (data.value.files?.length != 0)
              ? (_openBlock(), _createBlock(_component_el_divider, { key: 1 }))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_11, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value.files, (img, index) => {
                return (_openBlock(), _createBlock(CaseImages, {
                  key: index,
                  guid: img
                }, null, 8, ["guid"]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_TimeShow, {
                "date-iso-string": data.value.createdOn,
                type: "reportTime"
              }, null, 8, ["date-iso-string"])
            ])
          ])
        ])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value.replies, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "mx-3"
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["row border", item.isAdmin == true ? 'bg-light' : ''])
          }, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                (item.isAdmin == false)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createVNode(_component_UserAvatar, {
                        avatar: "",
                        name: "user",
                        side: "client",
                        size: "100px",
                        rounded: ""
                      }),
                      _hoisted_16
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _createVNode(_component_UserAvatar, {
                        avatar: "",
                        name: data.value.claimedAdminName,
                        side: "admin",
                        size: "100px",
                        rounded: ""
                      }, null, 8, ["name"]),
                      _createElementVNode("div", _hoisted_18, _toDisplayString(data.value.claimedAdminName), 1)
                    ]))
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", null, _toDisplayString(item.content), 1),
              (showTranslation.value && item.languages?.length != 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.languages, (languageObject, index) => {
                      return (_openBlock(), _createElementBlock("div", { key: index }, [
                        _createElementVNode("p", null, _toDisplayString(Object.keys(languageObject)[0]) + ": " + _toDisplayString(Object.values(languageObject)[0]), 1)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_21, [
                _createVNode(TranslateText, {
                  text: item.content,
                  case: item,
                  onTranslated: _cache[2] || (_cache[2] = ($event: any) => (fetchData(id.value)))
                }, null, 8, ["text", "case"])
              ]),
              (item.files?.length != 0)
                ? (_openBlock(), _createBlock(_component_el_divider, { key: 1 }))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_22, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.files, (img, index) => {
                  return (_openBlock(), _createBlock(CaseImages, {
                    key: index,
                    guid: img
                  }, null, 8, ["guid"]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createVNode(_component_TimeShow, {
                  "date-iso-string": item.createdOn,
                  type: "reportTime"
                }, null, 8, ["date-iso-string"])
              ])
            ])
          ], 2)
        ]))
      }), 128)),
      _createVNode(_component_el_divider),
      _createVNode(ReplyCase, {
        item: data.value,
        onReplied: replied
      }, null, 8, ["item"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})